import CryptoModal from "../CryptoModal";
import { CRYPTO_MODAL_WRAPPER_CLASS } from "../modalLayout";
import buyCryptoTag from "../../../assets/images/buy-crypto-tag.png";
import depositWallet from "../../../assets/images/deposit-wallet.png";

const ActionOption = ({ iconSrc, iconAlt, title, description, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex w-full items-center gap-4 rounded-[12px] border border-divider bg-background-surface px-4 py-4 text-left custom-transition hover:border-primary-300"
  >
    <img
      src={iconSrc}
      alt={iconAlt}
      className="h-[72px] w-[72px] shrink-0 object-contain"
    />
    <div className="min-w-0">
      <p className="text-sm font-semibold leading-[24px] text-text-primary">{title}</p>
      <p className="mt-1 text-xs leading-[18px] text-text-secondary">{description}</p>
    </div>
  </button>
);

const SelectActionModal = ({ isOpen, onClose, onBuyCrypto, onDepositCrypto }) => (
  <CryptoModal
    isOpen={isOpen}
    onClose={onClose}
    mobileBottomSheet
    contentSizedOnDesktop
    wrapperClassName={CRYPTO_MODAL_WRAPPER_CLASS}
    panelClassName="gap-5 pb-8 pt-6 sm:gap-6 sm:pb-6 sm:pt-8"
    headerClassName="items-start px-4 sm:pl-4"
    headerTabs={
      <h2 className="font-outfit text-base font-semibold leading-[24px] text-text-primary sm:ml-2 sm:text-lg">
        Step 1: Select what you want to do
      </h2>
    }
  >
    <div className="flex flex-col gap-4 px-4 font-outfit sm:px-6">
      <ActionOption
        iconSrc={buyCryptoTag}
        iconAlt="Buy crypto"
        title="Buy Crypto"
        description="Choose from supported cryptocurrencies and purchase securely with a smooth, beginner-friendly experience."
        onClick={onBuyCrypto}
      />

      <p className="text-center text-lg font-semibold text-text-secondary">Or</p>

      <ActionOption
        iconSrc={depositWallet}
        iconAlt="Deposit crypto"
        title="Deposit Crypto"
        description="Transfer crypto from another wallet or exchange securely into your Monfi account."
        onClick={onDepositCrypto}
      />
    </div>
  </CryptoModal>
);

export default SelectActionModal;
